<template>
    <div id="trunk">
        <lead :headOption="headOption"/>
        <main class="main">
            <router-view />
        </main>
        <foote/>
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";
export default {
    data() {
        return {
         // 顶部模块标题：
            headOption: {
                link: "/memorandum",
                title: "备忘录"
            },
        };
    },
    created() { },
    mounted(){},
    methods: {},
    components: {
        lead,
        foote
    }
};
</script>
<style lang="scss">
.main {
    box-sizing: border-box;
    min-height: calc(100vh - 124px);
    padding: 25px 0 40px;
}
.course-menunav a {
    display: block;
    line-height: 65px;
}
.max_W{
    max-width: 1200px;
    margin: 0 auto;
}
.quillWrapper{
    .ql-list,
    .ql-link,
    .ql-code-block,
    .ql-strike
    {
        display: none !important;
    }
}
.memorandum-lis-txt{
   p{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
   }
}

@media (max-width: 1380px) {
  .max_W{
      max-width: 1000px;
  }
}
</style>